module.exports = __webpack_public_path__ + "static/CV_Zeljka_Smoljan-a7156b3b2c47f15eb3dff7b502f3de90.pdf";